export const environment = {
  production: false,
  /*apiUrl: 'https://localhost:7250'*/
  apiUrl: ''
};
